import { GridRequest } from "../core";

export enum ImportedCouponStatus {
  Pending = "Pending",
  InProgress = "InProgress",
  Failed = "Failed",
  Created = "Created",
  Creating = "Creating"
}

export enum ImportedCouponPromotionType {
  Amount = "Amount",
  Percentage = "Percentage"
}

export enum ImportedCouponCodeMode {
  None = "None",
  Single = "Single",
  Multiple = "Multiple"
}

export interface ImportedCouponFilterDto {
  search?: string;
  status?: ImportedCouponStatus;
}

export type ImportedCouponGridRequestDto = GridRequest<ImportedCouponFilterDto>;

export interface ImportedCouponCodeDto {
  id: number;
  code: string;
  createdAt: string;
}

export interface ImportedCouponDetailDto {
  id: number;
  sourceSystem: string;
  externalCouponId: string;
  status: ImportedCouponStatus;
  promotionType: ImportedCouponPromotionType;
  name: string;
  code: string;
  title: string;
  subtitle: string;
  description: string;
  startDate: string;
  endDate: string;
  promotionValue: string;
  imageUrl: string;
  couponCodeMode: ImportedCouponCodeMode;
  importedAt: string;
  configuredAt: string;
  activatedAt: string;
  digitalCouponId: string;
  externalCouponUrl?: string;
  updatedAt: string;
  codesCount: number;
  couponCodes: ImportedCouponCodeDto[];
  payload?: string;
}

export interface ImportedCouponTypeDto {
  code: string;
  displayName: string;
  categoryId: string;
  iconUrl: string;
  active: boolean;
}

export interface CreateDigitalCouponsRequestDto {
  importedCouponIds: number[];
  importedCouponTypeId: string;
}

export interface ImportedCouponGetDto {
  id: number;
  name: string;
  status: ImportedCouponStatus;
  promotionType: ImportedCouponPromotionType;
  couponCodeMode: ImportedCouponCodeMode;
  title: string;
  subtitle: string;
  description: string;
  startDate: string;
  endDate: string;
  promotionValue: string;
  couponImageUrl: string;
  couponImportedDate: string;
  couponCreatedDate: string;
  couponActivatedDate: string;
  digitalCouponId: string;
}
